export { SecaoGenerica } from './SecaoGenerica'
